<template lang="pug">
  .container-reg-1
    el-steps(align-center).reg-steps
      el-step(title="填写账号密码", status="finish")
      el-step(title="完善商家资料")
      el-step(title="绑定联系方式")
    c-header-small
      template(slot="left")
        h3 填写账号密码
    el-form(:model="regForm", label-position="right", label-width="100px").reg-form
      el-form-item(label="账号")
        el-input(v-model="regForm.uname", placeholder='账号',auto-complete="off")
      el-form-item(label="") 请输入 6 ~ 20 位字母或数字作登陆账号
      el-form-item(label="密码")
        el-input(type="password", v-model="regForm.passwd", placeholder='密码', auto-complete="off")
      el-form-item(label="") 密码长度应为 8 ~ 20 位
      el-form-item(label="重复密码")
        el-input(type="password", v-model="regForm.confirm_passwd", placeholder='重复密码', @keyup.enter.native="reg", auto-complete="off")
      .reg-form-button-group
        el-button(type="primary", @click="reg", :disabled="isReg").reg-button 注册
</template>

<script>
export default {
  data() {
    return {
      regForm: {
        uname: "",
        passwd: "",
        confirm_passwd: "",
      },
      register_key: "",
      isReg: false,
      loading: false,
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    isMobile() {
      return window.browserInfo.isMobile;
    },
  },
  methods: {
    getUserInfo() {
      return this.$store.dispatch("GET_USER_INFO");
    },
    async getDetail() {
      try {
        let data = await this.$store.dispatch("LAST_SUCCEED_MCH_DETAIL");
        // 没有绑定手机或者邮件必须去绑定要一个
        if (!data.resp_per_telephone_no && !data.resp_per_email) {
          this.$router.replace("/reg/3");
        }else{
          this.$router.replace("/main");
        }
      } catch (error) {
        console.log(error);
        const { code, msg } = error;
        this.$alert(`商家审批信息获取失败。${code}：${msg}`, {
          type: "error",
        });
      }
    },
    next() {
      this.getUserInfo().then((userInfo) => {
        if (userInfo.fill_info === 1 && this.$route.path !== "/reg/2") {
          this.$router.replace("/reg/2");
        } else {
          this.getDetail();
        }
      });
      // this.$router.replace("/reg/2");
    },
    toMobile() {
      this.$router.replace({ path: "/reg-mobile/1", query: this.$route.query });
    },

    getRegisterKey(app_id, redirect_url, remark) {
      const params = { app_id, redirect_url, remark };
      return this.$store
        .dispatch("START_REGISTRY", params)
        .then((register_key) => {
          this.register_key = register_key;
          return register_key;
        })
        .catch(({ code, msg }) => {
          this.$message({
            type: "error",
            message: `注册流程初始化失败：${code}：${msg}`,
          });
        });
    },

    reg() {
      if (this.regForm.uname.length < 6 || this.regForm.uname.length > 20) {
        this.$message({
          type: "warning",
          message: `账号长度应为 6 ~ 20 位`,
        });
        return;
      } else if (this.regForm.passwd.length < 8 || this.regForm.passwd.length > 20) {
        this.$message({
          type: "warning",
          message: `密码长度应为 8 ~ 20 位`,
        });
        return;
      } else if (this.regForm.passwd !== this.regForm.confirm_passwd) {
        this.$message({
          type: "warning",
          message: `两次输入的密码不一致`,
        });
        return;
      }
      this.isReg = true;
      this.loading = true;
      const params = Object.assign({}, this.regForm, {
        register_key: this.register_key,
      });
      this.$store
        .dispatch("REGISTRY", params)
        .then(() => {
          this.$store
            .dispatch("LOGIN", this.regForm)
            .then(() => {
              this.next();
            })
            .catch(({ code, msg }) => {
              this.$message({
                type: "error",
                message: `登录失败：${code}：${msg}`,
              });
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(({ code, msg }) => {
          if (code === 41016) {
            this.$store
              .dispatch("LOGIN", this.regForm)
              .then(() => {
                this.next();
              })
              .catch(({ code, msg }) => {
                this.$message({
                  type: "error",
                  message: `登录失败：${code}：${msg}`,
                });
              });
          } else {
            this.$message({
              type: "error",
              message: `注册失败：${code}：${msg}`,
            });
          }
        })
        .finally(() => {
          this.isReg = false;
          this.loading = false;
        });
    },
  },
  mounted() {
    if (this.isMobile) {
      this.toMobile();
    } else {
      const query = this.$route.query;
      if (query.app_id && query.redirect_url) {
        const { app_id, redirect_url, remark } = query;
        this.getRegisterKey(app_id, redirect_url, remark);
      } else {
        this.$message({
          type: "error",
          message: `缺少注册流程初始化参数`,
        });
      }
    }
  },
};
</script>
